import { Card, Typography, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import SellerInformation from "../../../Components/SellerInformation";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";
import { useEffect } from "react";

const AddSeller = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage Canned Seller", permissionJson, "edit")) {
        navigate("/manage-seller");
      }
    } else {
      if (!checkPermissionAction("Manage Canned Seller", permissionJson, "add")) {
        navigate("/manage-seller");
      }
    }
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined
              className="mr-2"
              onClick={() => navigate("/manage-seller")}
            />
            {id ? "Edit" : "Add"} Canned Seller
          </Typography>
        </div>
        <Divider />
        <SellerInformation />
      </Card>
    </>
  );
};
export default AddSeller;
